import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'components/core/Button';
import { Paragraph } from 'components/core/Typography';

export const enhance = (WrappedComponent) => {
	const WithClickHandler = (props) => {
		const handleOnClick = () => {
			if (props.onClick) {
				props.onClick(props.type, props.selected ? null : props.value);
			}
		};
		return (
			<WrappedComponent
				{...props}
				handleOnClick={handleOnClick}
			/>
		);
	};
	return WithClickHandler;
};

export function FilterButton({
	icon,
	label,
	handleOnClick,
	selected,
	disabled = false,
}) {
	return (
		<Button
			primary={false}
			className={classnames('filter-button', { selected, disabled })}
			onClick={handleOnClick}
			disabled={disabled}
		>
			{!!icon && <span className="icon">{icon}</span>}
			<span>
				<Paragraph
					size="small"
					last={!disabled}
				>
					{label}
				</Paragraph>
				{disabled && <Paragraph size="tiny" weight="standard" last>No results available</Paragraph>}
			</span>
		</Button>
	);
}

FilterButton.propTypes = {
	icon: PropTypes.node,
	label: PropTypes.node,
	handleOnClick: PropTypes.func,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
};

export default enhance(FilterButton);
